<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3UbRvR/tc-custom/9781460329238.jpg?1740862303297" alt="This image is the cover for the book Defending the Eyewitness, Conard County: The Next Generation"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Defending the Eyewitness, Conard County: The Next Generation
      </h1>
      <p class="bookDescription body article font2">
        <b>The <i>New York Times</i>–bestselling author delivers “a page-turner full of mystery and suspense, keeping the reader engaged every step of the way” (<i>Fresh Fiction</i>).</b><br/><br/>The note wasn’t a threat, exactly. But for Corey Donahue, who’d witnessed her mother’s murder as a child, it felt very menacing. Surprisingly, the one person she trusted to show the note to was a man merely renting a room from her—Austin Mendez. Traumatized since childhood, Corey had never trusted men . . . until Austin moved in.<br/><br/>Six years undercover had caused Austin to shut everyone out . . . until Corey. The vulnerability she hid from others made him yearn to break down the walls she’d erected around her heart. And with a killer closing in, two lost souls were discovering the trust they’d lost—and much more—in each other’s arms.<br/><br/><b>“Two emotionally wounded characters draw readers into Lee’s story. Steady pacing, efficient and in-depth writing and a suspenseful plot keep the pages turning.” —<i>RT Book Reviews</i> (4 stars)</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rachel Lee
      </h2>
      
      <p class="authorDescription body article">Rachel Lee was hooked on writing by the age of twelve and has lived all over the United States. This New York Times bestselling author now resides in Florida and writes full-time. Research is one of her favorite things.<Br><Br>Rachel loves her pets nearly as much as her four children. She has had both dogs and cats and is currently enjoying the antics of Jazz, her bloodhound. She also calls him her &quot;Gentle Giant.&quot;<Br><Br>&#160;<Br><Br>&#160;<Br><Br>&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ea4e9acc